import { render } from "./NewTextAnalysisModal.vue?vue&type=template&id=7bc4d7d6"
import script from "./NewTextAnalysisModal.vue?vue&type=script&lang=js"
export * from "./NewTextAnalysisModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__